import axios from 'axios';

// Paket tipi: 'Aylık' veya 'Yıllık', port: int
export async function sendPaymentValidity(port, valid_until, customerName = '', extra = {}) {
  // API endpointleri: POST yeni ekler, PUT günceller
  const apiUrl = 'https://pdks.bytebridge.com.tr/api-validity';
  let exists = false;
  try {
    const res = await axios.get(apiUrl, { params: { port } });
    if (res.data && (res.data.length > 0 || res.data.Port || res.data.port)) exists = true;
  } catch (e) { exists = false; }

  // payload'a paket içeriklerini de ekle
  let paketIcerik = {};
  if (extra && typeof extra === 'object' && extra.paket) {
    // Eğer manuel değerler gelirse onları kullan
    paketIcerik = {
      paket: extra.paket,
      location_count: extra.location_count,
      employee_count: extra.employee_count,
      rfid_count: extra.rfid_count
    };
  } else if (extra && typeof extra === 'string') {
    // Sadece paket adı string olarak gelirse
    switch (extra.toLowerCase()) {
      case 'standart':
        paketIcerik = { paket: 'Standart', location_count: 1, employee_count: 25, rfid_count: 25 };
        break;
      case 'pro':
        paketIcerik = { paket: 'Pro', location_count: 99, employee_count: 100, rfid_count: 100 };
        break;
      case 'kurumsal':
        paketIcerik = { paket: 'Kurumsal', location_count: 9999, employee_count: 9999, rfid_count: 9999 };
        break;
      default:
        paketIcerik = { paket: extra };
    }
  } else if (extra && typeof extra === 'object' && extra.selected) {
    // Sadece seçili paket adı varsa
    switch (extra.selected.toLowerCase()) {
      case 'standart':
        paketIcerik = { paket: 'Standart', location_count: 1, employee_count: 25, rfid_count: 25 };
        break;
      case 'pro':
        paketIcerik = { paket: 'Pro', location_count: 99, employee_count: 100, rfid_count: 100 };
        break;
      case 'kurumsal':
        paketIcerik = { paket: 'Kurumsal', location_count: 9999, employee_count: 9999, rfid_count: 9999 };
        break;
      default:
        paketIcerik = { paket: extra.selected };
    }
  }

  const payload = {
    port,
    valid_until,
    customer_name: customerName,
    ...paketIcerik
  };

  if (exists) {
    // Güncelle (PUT)
    return axios.put(apiUrl, payload);
  } else {
    // Yeni ekle (POST)
    return axios.post(apiUrl, payload);
  }
}
